import React, { useEffect, useState } from "react";
import styles from "./Sidebar.module.sass";
import { Link, NavLink, useLocation } from "react-router-dom";
import MultiAccessControl from "../../HOC/MultiAccessControl";
import cn from "classnames";
import Icon from "../Icon";
import Theme from "../Theme";
import Dropdown from "./Dropdown";
import Help from "./Help";
import Image from "../Image";
import Logo from "../../assets/images/ppg_log.svg";
import DarkLogo from "../../assets/images/ppg_logo_in_dark.svg";
import Modal from "../Modal";
import InventoryMode from "../../screens/Inventory/InventoryMode";
import { Tooltip } from "antd";

const navigation = [
  {
    title: "Analytics",
    slug: "analytics",
    icon: "pie-chart",
    url: "/analytics",
    add: true,
    moduleCode:["fEf6a5"],
    permissions: ["fEg6c8"],
   
  },
  {
    title: "Orders",
    icon: "order",
    url: "/orders",
    moduleCode: ["diMGeD"],
    permissions: ["91VsM3"],
  },
  {
    title: "Staff",
    // slug: "staffs",
    icon: "profile-circle",
    url: "/staff",
    moduleCode: ["eV79MY"],
    permissions: ["xPGbZk"],
    // dropdown: [
    //   {
    //     title: "Staff list",
    //     url: "/staff",
    //   },
    //   {
    //     title: "Unassigned",
    //     url: "/orders/unassigned",
    //   },
    // ],
  },
  {
    title: "Scan Order",
    slug: "scan order",
    icon: "camera",
    moduleCode: ["8FZN9w","ee014d"],
    permissions: ["a2YwMA","badc77"],
    dropdown: [
      {
        title: "Pack Orders",
        url: "/scan-order"
      },
      {
        title: "Returns",
        url: "/return-to-origin",
      },
    ],
  },
  {
    title: "Inventory",
    slug: "inventory",
    icon: "store",
    moduleCode: ["Lzk3eg"],
    permissions: ["kXdmje"],
    dropdown: [
      {
        title: "Update Inventory",
        action: "openUpdateInventoryModal",
        url: "/updateinventory"
      },
      {
        title: "Inventory Logs",
        url: "/inventorylogs",
      },
    ],
  },
  {
    title: "Totes",
    slug: "totess",
    icon: "shopping-bag",
    url: "/totes",
    add: true,
    moduleCode:["9a7df7"],
    permissions: [
      "f6764b"
    ],
   
  },
  {
    title: "Settings",
    slug: "Settings",
    icon: "setting",
    url: "/settings",
    moduleCode: [
      "gsZHRE",
      "FvrVqN",
      "BjQPiy",
      "k5WoWh",
      "18q9ha",
      "VBaqtS",
      "2sxE9L",
    ],
    permissions: [
      "nnlrNJ",
      "nJLdKh",
      "OZnKi4",
      "kI6pTK",
      "4Yy3A1",
      "HRkhhh",
      "OFUpm7",
    ],
  },
  {
    title: "Add Manual Orders ",
    icon: "addicon",
    url: "/order/add",
    moduleCode: ["bHp1GE"],
    permissions: ["OggEqV"],
  },
  {
    title: "Products",
    slug: "products",
    icon: "diamond",
    url: "/products/add",
    add: true,
    moduleCode:[],
    permissions: [
     
    ],
   
  },
  {
    title: "Print Barcode",
    slug: "Print Barcode",
    icon: "print",
    url: "/print-barcode/add",
    add: true,
    moduleCode:[],
    permissions: [     
    ],   
  },
  
  // {
  //   title: "Scan Order",
  //   icon: "camera",
  //   url: "/scanorder",
  // },

  // {
  //   title: "Home",
  //   icon: "home",
  //   url: "/dashboard",
  // },
  // {
  //   title: "Products",
  //   slug: "products",
  //   icon: "diamond",
  //   add: true,
  //   dropdown: [
  //     {
  //       title: "Dashboard",
  //       url: "/products/dashboard",
  //     },
  //     {
  //       title: "Drafts",
  //       url: "/products/drafts",
  //       counter: "2",
  //       colorCounter: "#FFBC99",
  //     },
  //     {
  //       title: "Released",
  //       url: "/products/released",
  //     },
  //     {
  //       title: "Comments",
  //       url: "/products/comments",
  //     },
  //     {
  //       title: "Scheduled",
  //       url: "/products/scheduled",
  //       counter: "8",
  //       colorCounter: "#B5E4CA",
  //     },
  //   ],
  // },
  // {
  //   title: "Customers",
  //   slug: "customers",
  //   icon: "profile-circle",
  //   dropdown: [
  //     {
  //       title: "Overview",
  //       url: "/customers/overview",
  //     },
  //     {
  //       title: "Customer list",
  //       url: "/customers/customer-list",
  //     },
  //   ],
  // },
  // {
  //   title: "Shop",
  //   icon: "store",
  //   url: "/shop",
  // },
  // {
  //   title: "Income",
  //   slug: "income",
  //   icon: "pie-chart",
  //   dropdown: [
  //     {
  //       title: "Earning",
  //       url: "/income/earning",
  //     },
  //     {
  //       title: "Refunds",
  //       url: "/income/refunds",
  //     },
  //     {
  //       title: "Payouts",
  //       url: "/income/payouts",
  //     },
  //     {
  //       title: "Statements",
  //       url: "/income/statements",
  //     },
  //   ],
  // },
  // {
  //   title: "Promote",
  //   icon: "promotion",
  //   url: "/promote",
  // },
];

const Sidebar = ({ className, onClose }) => {
  const [visibleHelp, setVisibleHelp] = useState(false);
  const [visible, setVisible] = useState(false);

  const [isUpdateInventoryModalVisible, setIsUpdateInventoryModalVisible] =
    useState(false);
  const { pathname } = useLocation();
  const handleAction = (action) => {
    if (action === "openUpdateInventoryModal") {
      setIsUpdateInventoryModalVisible(true);
    }
  };
  useEffect(() => {
    if (!document.querySelector(".fixed-tooltip-container")) {
      const container = document.createElement("div");
      container.className = "fixed-tooltip-container";
      Object.assign(container.style, {
        position: "fixed",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        pointerEvents: "none",
        zIndex: 1000,
      });
      document.body.appendChild(container);
    }
  }, []);
  const handleInventoryConfirm = () => {
    setVisible(false);
    setIsUpdateInventoryModalVisible(false);
  };
  return (
    <>
      <div
        className={cn(styles.sidebar, className, {
          [styles.active]: visible,
        })}
      >
        <button className={styles.close} onClick={onClose}>
          <Icon name="close" size="24" />
        </button>
        <Link className={styles.logo} to="/" onClick={onClose}>
          <Image
            className={styles.pic}
            src={Logo}
            // srcDark="/images/logo-light.png"
            srcDark={DarkLogo}
            alt="Core"
          />
        </Link>
        <div className={styles.menu}>
          {navigation.map((x, index) =>
            x.url ? (
              <MultiAccessControl
                moduleCodes={x.moduleCode}
                requiredPrivileges={x.permissions}
              >
                {" "}
                <NavLink
                  className={cn(styles.item, {
                    [styles.active]: pathname === x.url,
                  })}
                  to={x.url}
                  key={index}
                  onClick={onClose}
                >
                  {" "}
                  {visible ? (
                    <Icon name={x.icon} size="24" />
                  ) : (
                    <Tooltip
                      placement="right"
                      title={x.title}
                      overlayClassName="fixed-tooltip"
                      getPopupContainer={() =>
                        document.querySelector(".fixed-tooltip-container")
                      }
                    >
                      <div className={styles.iconWrapper}>
                        <Icon name={x.icon} size="24" />
                      </div>
                    </Tooltip>
                  )}
                  {x.title}
                </NavLink>
              </MultiAccessControl>
            ) : (
              <MultiAccessControl
                moduleCodes={x.moduleCode}
                requiredPrivileges={x.permissions}
              >
                <Dropdown
                  className={styles.dropdown}
                  visibleSidebar={visible}
                  setValue={setVisible}
                  key={index}
                  item={x}
                  onClose={onClose}
                  onAction={handleAction}
                />
              </MultiAccessControl>
            )
          )}
        </div>
        <button className={styles.toggle} onClick={() => setVisible(!visible)}>
          <Icon name="arrow-right" size="24" />
          <Icon name="close" size="24" />
        </button>
        <div className={styles.foot}>
          {/* <button className={styles.link} onClick={() => setVisibleHelp(true)}> */}
          {/* <button className={styles.link}>
            <Icon name="help" size="24" />
            Help & getting started
            <div className={styles.counter}>8</div>
          </button> */}
          <Theme className={styles.theme} visibleSidebar={visible} />
        </div>
      </div>
      <Help
        visible={visibleHelp}
        setVisible={setVisibleHelp}
        onClose={onClose}
      />
      <div
        className={cn(styles.overlay, { [styles.active]: visible })}
        onClick={() => setVisible(false)}
      ></div>
      <Modal
        visible={isUpdateInventoryModalVisible}
        onClose={() => setIsUpdateInventoryModalVisible(false)}
      >
        {/* <InventoryMode /> */}
        <InventoryMode
          onClose={() => setIsUpdateInventoryModalVisible(false)}
          onConfirm={handleInventoryConfirm}
        />
      </Modal>
    </>
  );
};

export default Sidebar;
